const getYearsFromCreatedAt = (createdAt) => {
  if (!createdAt) return null;
  const created = new Date(createdAt);
  if (Number.isNaN(created.getTime())) return null;

  const now = new Date();
  let years = now.getFullYear() - created.getFullYear();
  const monthDiff = now.getMonth() - created.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < created.getDate())) {
    years -= 1;
  }

  return years >= 1 ? years : null;
};

export const formatCreativeExperience = (creative) => {
  const explicitYears = creative?.experience ?? creative?.user?.experience;
  if (explicitYears != null && explicitYears !== '') {
    return `${explicitYears} J.`;
  }

  const yearsFromCreatedAt = getYearsFromCreatedAt(creative?.createdAt);
  if (yearsFromCreatedAt != null) {
    return `${yearsFromCreatedAt} J.`;
  }

  return '-';
};

export const formatCreativeRating = (creative) => {
  const rating = creative?.averageRating;
  if (rating == null) return '-';

  return Number(rating).toLocaleString('de-DE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
};

export const hasCreativeRating = (creative) => creative?.averageRating != null;

export const formatCreativeBookings = (creative) => {
  const count = creative?.reviewCount;
  if (count == null) return '-';
  return count;
};
